import React, { useState, useEffect, useRef } from "react";
import {
  Checkbox,
  Button,
  Card,
  Container,
  FormControl,
  Autocomplete,
  TextField,
  Grid,
  Box,
  MenuItem,
  Select,
  InputLabel,
  Stack,
  Typography,
  createFilterOptions,
  Breadcrumbs,
  Link,
  Fab,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import Page from "../components/Page";
import DashboardBreadcrumbLink from 'src/components/DashboardBreadcrumbLink';
import {
  getCamerasList_Live,
  getCamerasList
} from "src/api/liveCameras";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import { getClientLocations } from 'src/api/ShiftMaster';
import { generateStreamURL } from 'src/utils/config';
import { useTheme, alpha } from '@mui/material/styles';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const groupicon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const groupcheckedIcon = <CheckBoxIcon fontSize="small" />;


export default function LiveCameras() {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const UI = {
    inputBg: isDark ? alpha(theme.palette.common.white, 0.06) : theme.palette.background.paper,
    inputText: theme.palette.text.primary,
    inputMuted: theme.palette.text.secondary,
    border: alpha(theme.palette.text.primary, isDark ? 0.26 : 0.18),
    borderHover: alpha(theme.palette.text.primary, isDark ? 0.44 : 0.28),
    cardBg: isDark ? '#1a2638' : theme.palette.background.paper,
    cardBorder: isDark ? alpha(theme.palette.common.white, 0.08) : alpha(theme.palette.text.primary, 0.16),
    shadow: isDark ? '0 8px 24px rgba(0, 0, 0, 0.28)' : '0 1px 3px rgba(0,0,0,0.08)',
  };
  const agentBased = localStorage.getItem('IsAgentBased');
  const [selectedGroup, setSelectedGroup] = useState("");
  const [selectedCameras, setSelectedCameras] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [liveCamerasList, setLiveCamerasList] = useState([]);
  const [camerasByGroupId, setCamerasByGroup] = useState([]);
  const [camerawithoutGroups, setCameraListWithoutGroups] = useState([]);
  const [allCameraWithoutGroups, setAllCameraListWithoutGroups] = useState([]);
  const [showOptions, setShowOptions] = useState(true);
  const [gridLayout, setGridLayout] = useState({ xs: 12 });
  const [errorMessage, setErrorMessage] = useState('');
  const [checkValue, setCheckValue] = useState(false);
  const [openAuto, setOpenAuto] = useState(false);
  const [activeCameras, setActiveCameras] = useState([]);
  const [inputValue, setInputValue] = useState([]);
  const [activeGroups, setActiveGroups] = useState([]);
  const [outerBoxWidth, setOuterBoxWidth] = useState('');
  const [outerBoxHeight, setOuterBoxHeight] = useState('');
  const [cameWidth, setCamewidth] = useState('');
  const [cameHeight, setCameHeight] = useState('');
  const [xsCount, setXSCountVal] = useState(null);
  const [isClient, setIsClient] = useState('');
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const client_id = localStorage.getItem('client_id');
  const [location, setLocation] = useState(() => {
    const stored = localStorage.getItem('selectedLocation');
    return stored ? parseInt(stored) : null;
  });
  const [locations, setLocations] = useState([]);
  // Ref to track if we've already triggered the submit
  const hasTriggeredSubmit = useRef(false);
  const [showGrid, setShowGrid] = useState(false);
  const [gridAreaHeight, setGridAreaHeight] = useState(null);
  const [viewportHeight, setViewportHeight] = useState(
    typeof window !== "undefined" ? window.innerHeight : 900
  );

  //const gymLocationId = localStorage.getItem('client_id')


  useEffect(() => {
    let userType = localStorage.getItem('user_type');
    if (userType === "2") {
      setIsClient(true);
    } else {
      setIsClient(false);
    }
  }, []);


  useEffect(() => {
    if (allCameraWithoutGroups.length > 0 && isInitialLoad && activeCameras.length === 0) {
      getCamerasSelectedList(allCameraWithoutGroups, location);
    }
  }, [allCameraWithoutGroups, locations]);

  const changeLocation = (value) => {
    setLocation(value);
    setInputValue(true);
    setActiveCameras([]);
    hasTriggeredSubmit.current = false;
    getCamerasSelectedList(allCameraWithoutGroups, value);
  }

  const getCamerasSelectedList = (allCameraWithoutGroups, location) => {
    // camerawithoutGroups having deviceid and locationId, filter the list based upon locationid
    // This function returns the cameras for the currently selected location
    const cameras = allCameraWithoutGroups.filter(
      (camera) => camera.LocationId === location
    );

    let numToSlice = 6;
    const firstCameras = cameras.slice(0, numToSlice);
    const firstDeviceIds = firstCameras.map(camera => camera.deviceid);
    setCameraListWithoutGroups(cameras);
    setActiveCameras(firstDeviceIds);
    setInputValue(firstCameras);
    setIsInitialLoad(false);
  }


  // New useEffect to trigger handleSubmit after activeCameras is updated
  useEffect(() => {
    if (isInitialLoad === false && activeCameras.length > 0 && !hasTriggeredSubmit.current) {
      hasTriggeredSubmit.current = true;
      handleSubmit();
    }
  }, [activeCameras, isInitialLoad]);



  useEffect(() => {
    const count = liveCamerasList.length;
    const shouldFitViewport = showGrid && count > 0 && count <= 20;
    const headerHeight = shouldFitViewport ? 100 : (showGrid ? 80 : 200);
    const availableHeight = Math.max(viewportHeight - headerHeight, 320);
  
    let rows = 1;
    let xs = 4;
  
    if (count <= 1) {
      rows = 1;
      xs = 12;
    } else if (count === 2) {
      rows = 1;
      xs = 6;
    } else if (count === 3) {
      rows = 1;
      xs = 4;
    } else if (count === 4) {
      rows = 2;
      xs = 6;
    } else if (count >= 5 && count <= 6) {
      rows = 2;
      xs = 4;
    } else if (count >= 7 && count <= 9) {
      rows = 3;
      xs = 4;
    } else if (count >= 10 && count <= 12) {
      rows = 3;
      xs = 3;
    } else if (count >= 13 && count <= 16) {
      rows = 4;
      xs = 3;
    } else if (count >= 17) {
      rows = Math.ceil(count / 5);
      xs = 2.4;
    } else {
      rows = Math.ceil(count / 4);
      xs = 3;
    }
  
    const rowGap = shouldFitViewport ? 16 : 0;
    const totalRowGaps = Math.max(rows - 1, 0) * rowGap;
    const usableHeight = Math.max(availableHeight - totalRowGaps, 220);
    const cardHeight = Math.max(Math.floor(usableHeight / rows), shouldFitViewport ? 120 : 220);
    const iframeHeight = cardHeight;
  
    setOuterBoxHeight(`${cardHeight}px`);
    setCameHeight(`${iframeHeight}px`);
    setXSCountVal(xs);
    setOuterBoxWidth('100%');
    setCamewidth('100%');
    setGridAreaHeight(shouldFitViewport ? availableHeight : null);
  }, [liveCamerasList, showGrid, viewportHeight]);
  
  useEffect(() => {
    const handleResize = () => {
      setViewportHeight(window.innerHeight);
    };
  
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // useEffect(() => {
  //   switch (liveCamerasList.length) {
  //     case 1:
  //       setOuterBoxWidth('100%');
  //       setOuterBoxHeight('82vh');
  //       setCamewidth('100%');
  //       setCameHeight('75vh');
  //       setXSCountVal(12);
  //       break;
  //     case 2:
  //       setOuterBoxWidth('100%');
  //       setOuterBoxHeight('62vh');
  //       setCamewidth('100%');
  //       setCameHeight('50vh');
  //       setXSCountVal(6);
  //       break;
  //     case 3:
  //       setOuterBoxWidth('100%');
  //       setOuterBoxHeight('42vh');
  //       setCamewidth('100%');
  //       setCameHeight('35vh');
  //       setXSCountVal(4);
  //       break;
  //     default:
  //       setOuterBoxWidth('100%');
  //       setOuterBoxHeight('42vh');
  //       setCamewidth('100%');
  //       setCameHeight('35vh');
  //       setXSCountVal(4);
  //       break;
  //   }
  // }, [liveCamerasList]);


  const handleSubmit = () => {

    setLiveCamerasList([]);
    if (activeCameras.length === 0) {
      setErrorMessage('Please Select Atleast One Camera');
      return;
    } else {
      setErrorMessage('');
      getCamerasList_Live(activeCameras, (response) => {
        if (response.status === 200) {
          // For deviceid 9730 and 9731, replace LiveUrl as specified
          if (Array.isArray(response.data)) {
            setLiveCamerasList(
              response.data.map(cam => {
                if (cam.deviceid === 9730) {
                  return { ...cam, LiveUrl: "https://service.vdointel.ai:9038/storage/Videos/gym/GYM_INDOOR_CAM_1.mp4" };
                }
                if (cam.deviceid === 9731) {
                  return { ...cam, LiveUrl: "https://service.vdointel.ai:9038/storage/Videos/gym/GYM_ENTRY_WAY.mp4" };
                }
                return cam;
              })
            );
          } else {
            setLiveCamerasList(response.data);
          }
          setSubmitted(true);
          setOpenAuto(false);
        }
      });
    }
  };

  const handleClear = () => {
    setLiveCamerasList([]);
    setSelectedCameras([]);
    setSelectedGroup("");
    setCamerasByGroup([]);
    setSubmitted(false);
    setActiveCameras([]);
    setOpenAuto(false);
    setInputValue([]);
    setCheckValue(false);
    hasTriggeredSubmit.current = false;
  };


  const handleLiveCamera = (event, newValue) => {
    setSelectedCameras(newValue);
    if (!newValue || newValue.length === 0) {
      setLiveCamerasList([]);
    }

    let lengthofCameras = camerawithoutGroups.length;
    let cameraValues = camerawithoutGroups;

    if (newValue.length > 1 && newValue.every((entry, index, arr) => JSON.stringify(entry) === JSON.stringify(arr[0]))) {
      newValue = [];
    }

    const containsAllProperty = newValue.some(obj => obj.hasOwnProperty('all'));

    if (containsAllProperty) {
      if (newValue.length === 1) {
        setSelectedCameras(cameraValues);
      } else {
        let val = newValue.filter(item => !item.all);
        setSelectedCameras(val);
      }
    }

    if (newValue.length === 0 || !containsAllProperty) {
      setCheckValue(false);
    }

    let actCameras = [];

    if (newValue.length > 0 && !containsAllProperty) {

      if (lengthofCameras === actCameras.length) {
        setCheckValue(true);
      }

      setActiveCameras([...actCameras]);
      setInputValue([...newValue]);
    }

    if (newValue.length > 0 && containsAllProperty) {
      let Cameras = cameraValues;
      actCameras = [];

      if (activeCameras && activeCameras.length === lengthofCameras) {
        setCheckValue(false);
        let deviceIds = [];

        deviceIds = newValue.filter(obj => !obj.hasOwnProperty('all')).map(obj => obj.deviceid);
        Cameras = Cameras.filter(item => !deviceIds.includes(item.deviceid));
        Cameras.forEach((row) => {
          actCameras.push(row.deviceid);
        });
        setInputValue(camerawithoutGroups);
        setActiveCameras([...actCameras]);
        // setOpenAuto(false);
        return;
      }

      if (!checkValue) {
        Cameras.forEach((row) => {
          actCameras.push(row.deviceid);
        });
        setActiveCameras([...actCameras]);
        setInputValue(camerawithoutGroups);
        setCheckValue(true);
      } else {
        setActiveCameras([]);
        setInputValue([]);
      }
    } else if (newValue.length === 0) {
      setActiveCameras([]);
      setCheckValue(false);
      setInputValue([]);
      // setOpenAuto(true);
    }
  };

  const showFilter = () => {
    setShowGrid(!showGrid);
  };

  const handleFilterOptions = (options, params) => {
    const filter = createFilterOptions();
    const filtered = filter(options, params);
    return [{ title: 'Select All', all: true }, ...filtered];
  };


  const generateIframeSrc = (camera) => {
    let frameUrl = '';
    if (camera.LiveUrl !== null && camera.LiveUrl && camera.LiveUrl !== 'null') {
      frameUrl = camera.LiveUrl
    }
    else {
      frameUrl = generateStreamURL(camera.substream);
    }

    return frameUrl;
  };



  useEffect(() => {
    const body = { client_id: Number(client_id) }

    getClientLocations(body, (response) => {

      if (response.status === 200) {

        setLocations(response.data);
        // setAllCameraListWithoutGroups(deviceGymData);
        setTimeout(() => {
          getCamerasList((response) => {
            if (response.status === 200) {
              if (response.data !== null) {
                //setCameraListWithoutGroups(response.data);
                setAllCameraListWithoutGroups(response.data);
              }
            }
          });
        }, 500);

        const stored = localStorage.getItem('selectedLocation');
        if (stored) {
          const found = response.data.find((loc) => loc.Id === parseInt(stored));
          if (found) {
            setLocation(found.Id);
          }
        } else {
          const first = response.data[0];
          if (first) {
            setLocation(first.Id);
            localStorage.setItem('selectedLocation', first.Id);
          }
        }
      }
    });

  }, []);

  return (
    <Page title="Live">
      <Container maxWidth="xxl" sx={{p:0}}>
        <Box sx={{ mb: 3 }}>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4">Live</Typography>
          </Box>
          <Breadcrumbs separator="•" aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/" sx={{ fontSize: '0.875rem' }}>Dashboard</Link>
            <Typography color="text.secondary" sx={{ fontSize: '0.875rem' }}>Live</Typography>
          </Breadcrumbs>
        </Box>

        <Box>  
          {!showGrid && (
            <Grid
                container
                spacing={1}
                sx={{
                  display: showOptions ? "flex" : "none",
                  p: 2,
                  mb: 2,
                  backgroundColor: UI.cardBg,
                  border: `1px solid ${UI.cardBorder}`,
                  borderRadius: 3,
                  boxShadow: UI.shadow,
                }}
              >
              <Grid container spacing={2}>

                <Grid item xs={12} sm={6} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Location</InputLabel>
                    <Select
                      value={location || ''}
                      label="Location"
                      onChange={(e) => {
                        const val = e.target.value;
                        localStorage.setItem('selectedLocation', val);
                        changeLocation(val);
                      }}
                    >
                      {locations.map((event) => (
                        <MenuItem key={event.Id} value={event.Id}>
                          {event.LocationName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Autocomplete
                    multiple
                    size="small"
                    id="tags-outlined-cameras"
                    options={camerawithoutGroups}
                    getOptionLabel={(option) => {
                      if (!option || typeof option !== 'object') return "";
                      if (option.all) return option.title || "Select All";
                      return option.devicename || "";
                    }}
                    onChange={handleLiveCamera}
                    disableCloseOnSelect
                    filterOptions={handleFilterOptions}
                    onInputChange={(event, newInputValue) => {
                      if (!newInputValue) setLiveCamerasList([]);
                    }}
                    value={
                      checkValue
                        ? [{ title: 'Select All', all: true }]
                        : inputValue.filter((camera) =>
                          activeCameras.includes(camera.deviceid)
                        )
                    }
                    renderTags={() => null}
                    clearOnBlur={true}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        height: 40,
                        backgroundColor: UI.inputBg,
                        color: UI.inputText,
                      },
                      '& .MuiInputLabel-root': {
                        color: UI.inputMuted,
                      },
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: UI.border,
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: UI.borderHover,
                      },
                      '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.primary.main,
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Camera"
                        placeholder="Search Camera Id Or Name..."
                        InputLabelProps={{ style: { color: UI.inputMuted } }}
                      />
                    )}
                    ListboxProps={{
                      sx: {
                        bgcolor: 'background.paper',
                        color: 'text.primary',
                      },
                    }}
                    renderOption={(props, option, { selected }) => (
                      <li {...props} style={{ backgroundColor: '#303030', color: '#e0e0e0' }}>
                        {activeGroups && option.all ? (
                          <>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8, color: theme.palette.primary.main }}
                              checked={checkValue}
                              onChange={() => setCheckValue(!checkValue)}
                            />
                            {option.title}
                          </>
                        ) : option.deviceid && activeGroups.length === 0 ? (
                          <>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8, color: theme.palette.primary.main }}
                              checked={activeCameras.includes(option.deviceid)}
                              onChange={() => {
                                const isChecked = activeCameras.includes(option.deviceid);
                                const newActiveCameras = isChecked
                                  ? activeCameras.filter((id) => id !== option.deviceid)
                                  : [...activeCameras, option.deviceid];
                                setActiveCameras(newActiveCameras);
                              }}
                            />
                            {option.devicename}
                          </>
                        ) : activeGroups.length > 0 && (
                          <>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8, color: theme.palette.primary.main }}
                              checked={activeCameras.includes(option.deviceid)}
                              onChange={() => {
                                const isChecked = activeCameras.includes(option.deviceid);
                                const newActiveCameras = isChecked
                                  ? activeCameras.filter((id) => id !== option.deviceid)
                                  : [...activeCameras, option.deviceid];
                                setActiveCameras(newActiveCameras);
                              }}
                            />
                            {option.devicename}
                          </>
                        )}
                      </li>
                    )}
                  />
                  {errorMessage && (
                    <Typography color="error" variant="body2" align="center">
                      {errorMessage}
                    </Typography>
                  )}
                </Grid>


                <Grid item xs={2} sx={{ display: 'flex', alignItems: 'center' }}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <LoadingButton variant="contained" onClick={handleSubmit} sx={{ height: 40, minWidth: 96 }}>
                      Submit
                    </LoadingButton>
                    <LoadingButton
                      variant="contained"
                      color="error"
                      onClick={handleClear}
                      sx={{ height: 40, minWidth: 96 }}
                    >
                      Cancel
                    </LoadingButton>
                  </Stack>
                </Grid>

              </Grid>
            </Grid>
          )}

          <Grid   
              sx={{
                backgroundColor: (theme) => theme.palette.background.default,
                padding: 0,
                minHeight: '50px',
              }}
              container
              spacing={0}
          >
            {submitted && liveCamerasList.length > 0 && (
              <Grid container spacing={0} mt={2} px={0} mb={2}>
                {liveCamerasList.map((camera, index) => (
                  <Grid item xs={xsCount} key={index}>
                    <Typography
                      variant="caption"
                      noWrap
                      sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        mb: 0,
                        px: 1,
                        py: 0.35,
                        borderTopLeftRadius: 4,
                        borderTopRightRadius: 4,
                        borderLeft: `1px solid ${UI.cardBorder}`,
                        borderRight: `1px solid ${UI.cardBorder}`,
                        borderTop: `1px solid ${UI.cardBorder}`,
                        background: UI.cardBg,
                        color: UI.inputText,
                        fontSize: '14px',
                        fontWeight: 500,
                        lineHeight: 1.2,
                        maxWidth: '100%',
                      }}
                    >
                      {camera.devicename}
                    </Typography>
                    <Card
                      sx={{
                        background: UI.cardBg,
                        border: `1px solid ${UI.cardBorder}`,
                        boxShadow: UI.shadow,
                        borderRadius: 1,
                        padding: 0,
                        height: outerBoxHeight,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        overflow: 'hidden',
                        color: UI.inputText
                      }}
                    >
                      <Box
                        sx={{
                          position: 'relative',
                          width: '100%',
                          height: cameHeight,
                        }}
                      >
                        {(() => {
                          const src = generateIframeSrc(camera);
                          // Check if src is an mp4 file
                          const isMp4 = typeof src === "string" && src.match(/\.mp4(\?|$)/i);
                          if (isMp4) {
                            // Render a looping HTML5 video for mp4
                            return (
                              <video
                                src={src}
                                style={{
                                  width: cameWidth,
                                  height: cameHeight,
                                  border: 'none',
                                  padding: 0,
                                  margin: 0
                                }}
                                controls
                                autoPlay
                                loop
                              >
                                Your browser does not support the video tag.
                              </video>
                            );
                          } else {
                            // Render the original iframe for non-mp4 sources
                            return (
                              <iframe
                                id="fp_embed_player"
                                src={src}
                                allowFullScreen={true}
                                style={{
                                  width: cameWidth,
                                  height: cameHeight,
                                  border: 'none',
                                  padding: 0,
                                  margin: 0
                                }}
                              />
                            );
                          }
                        })()}
                      </Box>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            )}
          </Grid>
        </Box>

        <Fab
          color="primary"
          aria-label={showGrid ? "show-filters" : "hide-filters"}
          onClick={showFilter}
          sx={{
            position: 'fixed',
            bottom: 24,
            right: 24,
            zIndex: (theme) => theme.zIndex.drawer + 2,
          }}
        >
          {showGrid ? <FilterAltIcon /> : <FilterAltOffIcon />}
        </Fab>
      </Container>
    </Page>
  );
}
